import LineChartViz from '../vizs/LineChartViz'
import BaseComponent from './BaseComponent'
/**
 * {-EN-}
 * # {componentLabel} (`class {componentClassName}`)
 * A line chart or line plot or line graph or curve chart is a type of chart which displays information as a series of data points called 'markers' connected by straight line segments.
 *
 * ### Example Usage
 * ```javascript
 *
 *   import {StackedArea} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new StackedArea($el, data, config);
 *
 * ```
 *
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 2 or more columns.
 *
 * Each row represents a point in the X axis. The first column should be the id/label of each point. The rest of the columns should represent the values for each of the areas in the chart.
 *
 * |  xValue    | area1  |  area2   |  area3   |
 * | --------   | ------ |  ------  |  ------  |
 * |   0       |    22.4|      15.4|      43.2|
 * |   1      |    52.3|      29.3|      12.8|
 * |   2      |    12.8|      34.1|      61.4|
 * |   3      |    26.0|      12.3|      14.5|
 *
 * {.data-table}
 *
 * Areas will be stacked in the orther in which they appear in the table.
 *
 * {-ES-}
 * # {componentLabelEs} (`class {componentClassName}`)
 * Un gráfico de área es un tipo de gráfico que muestra información como una serie de puntos de datos llamados "marcadores" conectados por segmentos de línea recta.
 *
 * ### Ejemplo de uso
 * ```javascript
 *
 *   import {StackedArea} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new StackedArea($el, data, config);
 *
 * ```
 *
 * ### Estructura de datos {.section-data-structure}
 * Los datos tabulares de este gráfico deben ser una tabla con 2 o más columnas.
 *
 * Cada fila representa un punto en el eje X. La primera columna debe ser la identificación/etiqueta de cada punto. El resto de las columnas deben representar los valores de cada una de las áreas del gráfico.
 *
 * |  xValue    | area1  |  area2   |  area3   |
 * | --------   | ------ |  ------  |  ------  |
 * |   0       |    22.4|      15.4|      43.2|
 * |   1      |    52.3|      29.3|      12.8|
 * |   2      |    12.8|      34.1|      61.4|
 * |   3      |    26.0|      12.3|      14.5|
 *
 * {.data-table}
 *
 * Las áreas se apilarán en la otra en la que aparecen en la tabla.
 * */
export default class StackedAreaComponent extends BaseComponent {
  static vizClass = LineChartViz
  static dataFormat = [
    {
      index: 0,
      axis: 'x0',
      label: 'id',
      types: [Number, Date, String],
      role: 'id',
      roleLabel: 'X value - Number, Date (dd-mm-yyyy) or String',
    },
    { index: -1, axis: 'y0', label: 'Line', types: [Number], role: 'value', roleLabel: 'Y value' },
  ]
  static componentLabel = 'Area chart'
  static componentLabelEs = 'Gráfico de área'
  static defaultConfig = {
    title: this.componentLabel,
    mode: 'areas',
    interpolateLine: {
      default: false,
      exposed: false,
      nonEditable: true,
    },
    hasColorPatterns: {
      type: Boolean,
      default: true,
      exposed: false,
    },
    LegendBehavior: {
      icon: 'square',
    },
    ItemsHelper: {
      colorMode: 'fill',
    },
    gradientFill: {
      value: false,
      nonEditable: true,
    },
    TooltipBehavior: {
      axis: {
        x: {
          tooltipValueFormat: {
            exposed: true,
            nonEditable: false,
          },
        },
        y: {
          tooltipValueFormat: {
            exposed: true,
            nonEditable: false,
          },
        },
      },
    },
  }
  static dataRequirements = {
    recomendedMaxCols: 6,
    recomendedMinCols: 2,
    maxCols: 20,
    sign: 'positive', //'negative','any','both'
    requirementsStrength: 10,
    customMultiplier: (rows, types) => {
      console.log(types)
      if (types[0] === Date) return 2
      else if (types[0] === Number) return 1
      else if (types[0] === String) return 0.5
    },
  }
}
